<template>
  <div class="section">
    <div class="content">
      <h1>{{  getTopic(this.$route.params.topicId).title }}</h1>

      <p>Created: {{  getTopic(this.$route.params.topicId).created }}</p>
      <p>Last update: {{  getTopic(this.$route.params.topicId).last_update }}</p>

      <h3>Monitored channels</h3>
      <div class="field" v-for="(source, idx) in getTopic(this.$route.params.topicId).data_source" :key="'ds'+idx">
        <label class="label"><strong>{{ source.name}}</strong></label>
        <div class="control">
          <input class="input" :value="source.query"/>
        </div>

      </div>
      <h3>History</h3>

         <table class="table is-striped">

        <thead>
        <tr>
          <th>Date</th>
          <th>Text</th>



        </tr>
        </thead>
        <tbody>
        <tr v-for="(row,idx) in  getTopic(this.$route.params.topicId).history" :key="'r'+idx" style="height: 60px;">


          <td>{{ row.date }}</td>
          <td>{{ row.text }}</td>


        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

import {mapGetters} from 'vuex'

export default {
  components: {},

  data() {
    return {}
  },

  computed: {
    ...mapGetters({
      getTopic: 'getTopic'
    })
  }
}


</script>
